import React, { useState } from 'react';
import Lottie from 'react-lottie-player';
import APP_LOADER_ANIMATION from 'assets/animations/app-loader.json';
import { useSpring, animated } from 'react-spring';

import styled from 'styled-components';

const LoaderContainer = styled(animated.div)`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  min-height: 100%;
  background-color: transparent;
`;

const AppLoader = ({ is_loading, children }: $TSFixMe) => {
  const [show, setShow] = useState(true);
  const fadeout_styles = useSpring({
    from: {
      opacity: 1,
    },
    to: { opacity: is_loading ? 1 : 0 },
    delay: 1000,
    onRest: () => setShow(false),
  });

  return (
    <div>
      {show ? (
        <LoaderContainer style={fadeout_styles}>
          <Lottie
            animationData={APP_LOADER_ANIMATION}
            play
            style={{ width: 200, height: 200 }}
          />
        </LoaderContainer>
      ) : (
        children
      )}
    </div>
  );
};

export default AppLoader;
